import { render, staticRenderFns } from "./ApexChartHeader.vue?vue&type=template&id=90c1e134&"
import script from "./ApexChartHeader.vue?vue&type=script&lang=js&"
export * from "./ApexChartHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports